import AgreementCard from './AgreementCard';

export default AgreementCard;
